<template>
  <div class="list-item-file list-item-file-lab-result smd-panel m-b-20"
       @click="viewFile">
    <div class="file">
      <img :src="$options.HpLogo" class="file-icon file-icon-image"/>
      <div class="text" :class="{'m-l-10': !$isDesktop}">
        <h2 class="list-item-file__title" :class="!$isDesktop ? 'm-b-10 Title1' : 'm-b-20 Title2'">
          {{ getElementString('txt044') }}
        </h2>
        <text-string :label-id="$isDesktop ? 'txt040__desktop' : 'txt040'"
                     :props="{strings: [formattedPatientName, '']}"
                     :class="{'m-b-5': $isDesktop}"/>
        <p class="gray-400" :class="$isDesktop ? 'Label1' : 'Body3'">{{ formattedDate }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import TitleMixin from '@/mixins/title-mixin';
  import Routes from "@/router/routes";
  import PreviewFileType from "@/reference/preview-file-type";
  import GetElementString from "@/mixins/get-element-string";
  import HpLogo from "@/assets/images/img007.png"
  import {formatDate} from "@/utils/dates";

  export default {
    name: "list-item-file-labresult",
    mixins: [TitleMixin, GetElementString],
    props: {
      fileData: {type: Object, required: false},
      patientName: {type: String, default: null},
      showCouponButton: {type: Boolean, default: false}
    },
    computed: {
      formattedDate() {
        return formatDate(this.fileData.datereceived, '[Sent on] MMMM DD, YYYY [at] h:mm a');
      },
      formattedPatientName() {
        if (this.fileData.patientname) return this.fileData.patientname;
        if (this.patientName) return this.patientName;
        const patient = this.fileData.patient;
        if (patient) return `${patient.firstname} ${patient.lastname}`;
        return '';
      },
    },
    methods: {
      viewFile() {
        this.$router.push(
          {
            name: Routes.PREVIEW_FILE_LAB_REQUEST,
            params: {
              file: [this.fileData],
              title: this.getElementString('txt044'),
              filesView: true,
              type: PreviewFileType.PREVIEW_TYPE_PRESCRIPTION,
              token: this.fileData.token,
              showCouponButton: false
            },
          }
        )
      },
    },
    HpLogo
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .list-item-file-lab-result {
    .file-icon-image {
      @include responsive(desktop) {
        width: 120px;
        height: 120px;
      }
      width: 48px;
      height: 48px;
    }

    .file {
      @extend %layout--flex-row;
      flex-direction: row;
      align-items: normal;

      @include responsive(desktop) {
        align-items: center;
      }
    }
  }

</style>